import { render, staticRenderFns } from "./Advance_Client.vue?vue&type=template&id=23490a60&scoped=true&"
import script from "./Advance_Client.vue?vue&type=script&lang=js&"
export * from "./Advance_Client.vue?vue&type=script&lang=js&"
import style0 from "./Advance_Client.vue?vue&type=style&index=0&id=23490a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23490a60",
  null
  
)

export default component.exports